import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import CSSPlugin from 'gsap/CSSPlugin';
gsap.registerPlugin(ScrollTrigger, CSSPlugin);

//
import Swiper from 'swiper';
import { Autoplay, Pagination, Scrollbar, Navigation, EffectCoverflow } from 'swiper/modules';
Swiper.use([Autoplay, Pagination, Scrollbar, Navigation, EffectCoverflow]);

window.addEventListener("load", function () {

	const swiperParam = {
		loop: true,
		//centeredSlides: true,
		slidesPerView: 1.32,
		spaceBetween: 11,
		autoplay: {
			delay: 0,
		},
		speed: 15000,
		//initialSlide: 2,
		breakpoints: {
			1024: {
				slidesPerView: "auto",
			},
		}
	}
	new Swiper('.hero', swiperParam);


});
